/**
 * JSDoc imports.
 *
 * @import { DesignLanguage } from './design-language';
 */

export enum DesignPromptDynamicType {
  /** Use @see DesignLanguage.ttsFallBackVoice for the full text. */
  fullTts = 'TTS',
  /** Same as @see fullTts, but PE does not add SSML because it is assumed the designer already did. */
  fullTtsWithSsml = 'FULL_TTS_WITH_SSML',
  /** Use @see DesignLanguage.voice except for variables which use @see DesignLanguage.ttsFallBackVoice. */
  substitutionTts = 'SUBSTITUTION_TTS',
  /**
   * Use @see DesignLanguage.voice concatenation for everything including variables where possible.
   * Fall back to @see DesignLanguage.ttsFallBackVoice.
   */
  ttp = 'TTP',
}
